import styled from 'styled-components';

const Label = styled.label`
  display: flex;
  align-items: center;

  color: ${({ $color }) => $color || 'var(--content-body)'};
  font-family: var(--font-family-title);
  line-height: 1.5;

  font-size: ${({ $small }) => {
    if ($small) return '12px';

    return '14px';
  }};

  font-style: normal;
  letter-spacing: ${({ $small }) => ($small ? '-0.02em' : 0)};
  font-weight: 700;
  margin: 0;
`;

export { Label };
